import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/races',
    name: 'races',
    component: () => import('../views/RacesView.vue')
  },
  {
    path: '/standings',
    name: 'standings',
    component: () => import('../views/StandingsView.vue')
  },
  {
    path: '/drivers',
    name: 'drivers',
    component: () => import('../views/DriversView.vue')
  },
  {
    path: '/race/:season/:round',
    name: 'RaceDetail',
    component: () => import('../views/RaceDetailView.vue'),
    props: true
  },
  {
    path: '/world-gp',
    name: 'WorldGp',
    component: () => import('../views/WorldGpView.vue')
  },
  {
    path: '/live-telemetry',
    name: 'LiveTelemetry',
    component: () => import('../views/LiveTelemetryView.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/teams',
    name: 'Teams',
    component: () => import('../views/TeamsView.vue')
  },
  {
    path: '/teams/:slug',
    name: 'TeamDetail',
    component: () => import('../views/TeamDetailView.vue'),
    props: true
  },
  {
    path: '/compare',
    name: 'Compare',
    component: () => import('../views/DriverCompareView.vue')
  },
  {
    path: '/stats',
    name: 'Stats',
    component: () => import('../views/StatsView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
